module.exports = __webpack_public_path__ + "img/poziom12.f3bd32a1.svg";